<mat-form-field>
  <mat-label>Common select</mat-label>
  <mat-select [(value)]="selectedNewParticipantType">
    <mat-option *ngFor="let option of options" [value]="option.type">
      {{option.type}}
    </mat-option>
  </mat-select>
</mat-form-field>
